<template>
  <div v-if="!isHyptoLoader && showBanner" class="promotion">
    <div class="promotion-banner">
      <i class="fa fa-times" @click="closeBanner" />
      <img :src="bannerImg" class="banner" @click="redirectUrl" />
    </div>
  </div>
</template>

<script>
import Promo1 from '@/assets/images/GCP_1.gif'
import { mapGetters } from 'vuex'

export default {
  name: 'PromotionBanner',
  props: {
    bannerImg: {
      default: Promo1
    }
  },
  data () {
    return {
      showBanner: true
    }
  },
  computed: {
    ...mapGetters(['isHyptoLoader'])
  },
  methods: {
    closeBanner () {
      this.showBanner = false
    },
    redirectUrl () {
      window.open('https://hypto.in/hdfc-life', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

.promotion {
  display: flex;
  justify-content: center;
}

.promotion-banner {
  position: relative;
  cursor: pointer;

  .fa-times {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    padding: 10px;
    color: #6b6c6d;
    border: 2px solid #6b6c6d;
  }
}

.desktop {
  .banner {
    margin: 15px;
  }
}
</style>
